import { FC, ReactElement } from "react";

import {
  BulkGridSelectionControl,
  EditGridColumnButton,
  PanelTopSearchMobileLine,
  PanelTopStatCommon,
  PassengersMapToggleButton,
} from "@ryde/layout";
import { usePageContext } from "@ryde/redux";
import { isEntityWithoutBulkActions, useIsMobile } from "@ryde/shared";

import { PassengersPanelTopWrapper } from "./parts";

interface IPassengersPanelTopProps {
  StartAddition?: ReactElement;
  PanelTopStatCommonReplacement?: ReactElement;
}

export const PassengersPanelTop: FC<IPassengersPanelTopProps> = ({
  StartAddition,
  PanelTopStatCommonReplacement,
}) => {
  const { entity } = usePageContext();
  const { isMobile } = useIsMobile();
  const showBulkGridSelection = !isEntityWithoutBulkActions(entity);

  if (isMobile) {
    return <PanelTopSearchMobileLine />;
  }

  return (
    <PassengersPanelTopWrapper>
      {showBulkGridSelection && <BulkGridSelectionControl />}
      {!isMobile && <PassengersMapToggleButton />}

      <div className="panelTopRight">
        {Boolean(StartAddition) && StartAddition}
        {Boolean(PanelTopStatCommonReplacement) &&
          PanelTopStatCommonReplacement}
        {!PanelTopStatCommonReplacement && <PanelTopStatCommon />}
        <EditGridColumnButton />
      </div>
    </PassengersPanelTopWrapper>
  );
};
